// İskonto anahtarı çözümü — backend `_disc_lookup` ile aynı öncelik: Seri ("MARKA › SERİ") > Çeşit (discount_group) > Marka
export const SERIES_SEP = " › ";

export const seriesKey = (p) => {
  const b = String(p?.brand || "").trim();
  const s = String(p?.series || "").trim();
  if (!s) return "";
  return b ? `${b}${SERIES_SEP}${s}` : s;
};

export const discountKeys = (p) => [seriesKey(p), String(p?.series || "").trim(), String(p?.discount_group || "").trim(), String(p?.brand || "").trim()].filter(Boolean);

/** map: {anahtar: iskonto%}. Eşleşme yoksa null. */
export const discountFor = (p, map) => {
  if (!map) return null;
  for (const k of discountKeys(p)) if (map[k] != null) return Number(map[k]);
  return null;
};

/** Ürün → satır alanları (iskonto anahtarı için gereken alanlar korunur) */
export const productDiscountFields = (p) => ({ discount_group: p?.discount_group || "", brand: p?.brand || "", series: p?.series || "" });
